import './styles/main.css';
import { App } from './components/App.ts';

const app = new App();
app.init();
